import { useQuery } from '@apollo/client';
import { ReactNode, useMemo } from 'react';
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form';

import { GetLosIdsForCompanyDocument, LoanStatus } from '@willow/graphql-iso/src/app';
import { CompanyId, LosId } from '@willow/types-iso';

import { ControlledSelect } from './ControlledSelect';

type Props<T extends FieldValues> = {
  companyId: CompanyId;
  fieldName: FieldPathByValue<T, string[]>;
  control: Control<T>;
  hideErrorMessage?: boolean;
  label?: ReactNode;
  placeholder?: string;
  required?: boolean;
  excludeStatuses?: LoanStatus[];
  hint?: ReactNode;
};

interface LosSelectOption {
  label: LosId;
  value: LosId;
}

export function ControlledLosIdMultiSelect<T extends FieldValues>(props: Props<T>) {
  const { companyId, excludeStatuses } = props;
  const { data } = useQuery(GetLosIdsForCompanyDocument, { variables: { companyId, excludeStatuses } });
  const losOptions: LosSelectOption[] = useMemo(() => {
    const loans = data?.company.loanIdentifiers ?? [];
    return loans.map((loan) => ({
      value: loan.losId,
      label: loan.losId,
    }));
  }, [data?.company.loanIdentifiers]);

  return <ControlledSelect options={losOptions} isMulti closeMenuOnSelect={false} {...props} />;
}
